import L from "leaflet";
import * as React from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableCell,
  TableRow,
} from "@mui/material";
import airports from "./airports.json";

const airportIconUrl =
  process.env.PUBLIC_URL + "/mapicons/Airport/Airportv2.png";

const airportIcon = L.icon({
  iconUrl: airportIconUrl,
  iconSize: [23, 23],
  popupAnchor: [0, 0],
});

const getLeafletIcon = (feature, latlng, map, pane) => {
  const properties = feature.properties;
  const title = `${properties.name} (${properties.code})`;
  return L.marker(latlng, {
    icon: airportIcon,
    title: title,
    alt: title,
    pane: pane,
  });
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  return <Airport feature={feature} />;
};

const Airport = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="Airport"
            src={airportIconUrl}
            sx={{ width: 28, height: 28 }}
            aria-label="Airport"
          ></Avatar>
        }
        title={<font className="layer-title"> {properties.name} </font>}
        sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
        className={"styledtablerow"}
      />
      <CardContent
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <Table size="small">
          <TableRow>
            <TableCell className={"layertablecellLeft"}>Code</TableCell>
            <TableCell className={"layertablecellRight"}>
              {properties.code}
            </TableCell>
          </TableRow>
          {properties.url && (
            <TableRow className={"styledtablerow"}>
              <TableCell className={"layertablecellLeft"}>Website</TableCell>
              <TableCell className={"layertablecellRight"}>
                <a
                  href={properties.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hyper-links"
                >
                  {" "}
                  Visit site{" "}
                </a>
              </TableCell>
            </TableRow>
          )}
        </Table>
      </CardContent>
    </Card>
  );
};

const module = {
  name: "Airports",
  geoJson: airports,
  showOnMap: true,
  getLeafletIcon: getLeafletIcon,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon: airportIconUrl,
  zIndex: 616,
};

export default module;
